"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function debounce(func, delay) {
    if (delay === void 0) { delay = 100; }
    var timeoutId;
    return function () {
        var args = arguments;
        clearTimeout(timeoutId);
        timeoutId = setTimeout(function () {
            func.apply(null, args);
        }, delay);
    };
}
exports.debounce = debounce;
